<template>
  <nav
    class="navbar is-fixed-top is-dark"
    role="navigation"
    aria-label="main navigation"
  >
    <div class="navbar-brand">
      <div class="navbar-item">
        <img class="sl-logo" src="../../assets/logo.png" />
      </div>
      <p class="title-p" style="margin: auto 0px;">SKILLCOURT</p>
    </div>

    <div id="navbar-content" class="navbar-menu">
      <div class="navbar-start"></div>
    </div>
  </nav>
</template>

<script>
import $ from "jquery";
export default {
  data: function() {
    return {};
  },
  methods: {},
  mounted: function() {},
};
</script>
